// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_FAB_FILTER_POPULAR_GROUP: 'ha_fab_filter_popular_group',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_IDA_SERP_HEADER_LOGIN_TEST: 'HA_IDA_SERP_HEADER_LOGIN_TEST',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_MULTIUNIT_DECORATOR_TEST: 'ha_multiunit_decorator_test',
    HA_MULTIUNIT_PHOTO_CAROUSEL_TEST: 'HA_MULTIUNIT_PHOTO_CAROUSEL_TEST',
    HA_PTA_AFFILIATE_CO_BRAND: 'HA_PTA_AFFILIATE_CO_BRAND',
    HA_PTA_AFFILIATE_CO_BRAND_SHOW_LOGO: 'HA_PTA_AFFILIATE_CO_BRAND_SHOW_LOGO',
    HA_PTA_LANDING_SERP_ON_PLATFORM_SEO_LINKPILE:
        'HA_PTA_LANDING_SERPOnPlatformSEOLinkpile',
    HA_PULSE_MWEB_MODAL_LIST_VIEW: 'ha_pulse_mweb_modal_list_view',
    HA_PULSE_SAVE_CONFIRMATION_SERP_HIT: 'ha_pulse_save_confirmation_serp_hit',
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS',
    HA_SERP_DOCK_PAGER_PANEL: 'HA_SERP_DOCK_PAGER_PANEL',
    HA_SERP_FREE_CANCELLATION_V2: 'HA_SERP_FREE_CANCELLATION_V2',
    HA_SERP_MIN_MAX_PRICE_FIELDS: 'HA_SERP_MIN_MAX_PRICE_FIELDS',
    HA_SERP_MOBILE_GEO_DISTANCE: 'HA_SERP_MOBILE_GEO_DISTANCE',
    HA_SERP_NO_COOKIED_TRIPDATA_REDIRECTS:
        'HA_SERP_NO_COOKIED_TRIPDATA_REDIRECTS',
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS',
    HA_SERP_PREFETCH_HITS: 'HA_SERP_PREFETCH_HITS', // server-side only
    HA_SERP_SEARCH_TERM_CAROUSEL2: 'HA_SERP_SEARCH_TERM_CAROUSEL2',
    HA_SERP_VIRTUAL_TOUR_BADGE: 'HA_SERP_VIRTUAL_TOUR_BADGE',
    HA_SERP_ZERO_RESULTS_BANNER: 'HA_SERP_ZERO_RESULTS_BANNER',
    HA_SRS_SERIAL_PERCENT_BOOKED: 'HA_SRS_SERIAL_PERCENT_BOOKED',
    VRBO_RANK_PINNED_UI_BLPP: 'ha_pdp_preferred_location_for_pinned_property'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
